export const DATASETTYPE = 'datasetType'
export const DATASETFORMAT = 'datasetFormat'

export const isDataset = item => {
  return DATASETFORMAT in item
}
